// @flow

// Mapping table for old Firefoxes.
// See https://developer.mozilla.org/de/docs/Web/API/KeyboardEvent/key/Key_Values
const keyMap = {
	Esc: "Escape",
	Left: "ArrowLeft",
	Up: "ArrowUp",
	Right: "ArrowRight",
	Down: "ArrowDown",
	Del: "Delete",
};

// Mapping table for other browsers not support `key`.
const codeMap = {
	// $FlowFixMe: https://github.com/facebook/flow/issues/380
	8: "Backspace",
	// $FlowFixMe
	13: "Enter",
	// $FlowFixMe
	27: "Escape",
	// $FlowFixMe
	32: " ", // Space
	// $FlowFixMe
	35: "End",
	// $FlowFixMe
	36: "Home",
	// $FlowFixMe
	37: "ArrowLeft",
	// $FlowFixMe
	38: "ArrowUp",
	// $FlowFixMe
	39: "ArrowRight",
	// $FlowFixMe
	40: "ArrowDown",
};

export default function (ev: KeyboardEvent) {
	const key = ev.key;
	if (key) {
		return keyMap[key] || key;
	}
	const code = ev.keyCode || ev.which;
	return codeMap[code];
}

export const OUT = ["Escape"];
export const IN = ["Enter", " "];
export const LEFT = ["ArrowLeft"];
export const RIGHT = ["ArrowRight", " "];
export const UP = ["ArrowUp", "PageUp", "Home"];
export const DOWN = ["ArrowDown", "PageDown", "End", " "];



// WEBPACK FOOTER //
// ./lib/components/mapkey.js